// extracted by mini-css-extract-plugin
module.exports = {"MoreActions":"Actions_MoreActions__38kRi"};